import { createContext, useMemo, useState } from 'react';
import { BasicConnectors } from '../data/connector';
import { Vehicle } from '../data/vehicle';

export interface IVehicleContext {
  vehicle: Vehicle | undefined;
  capacityFull: [number, number] | undefined; // Capacity full + range real 
  powerMaxStandard: number | undefined;
  powerMaxFast: number | undefined;
  basicConnectors: BasicConnectors | undefined;
  optionalConnectors: string[];
  setVehicle: (vehicle: Vehicle | undefined) => void,
  setCapacityFull: (capacity: [number, number] | undefined) => void,
  setPowerMaxStandard: (powerMaxStandard: number | undefined) => void,
  setPowerMaxFast: (powerMaxStandard: number | undefined) => void,
  setBasicConnectors: (basicConnectors: BasicConnectors) => void,
  clearOptionalConnectors: (optionalConnector: string) => void,
  setOptionalConnectors: (optionalConnectors: string[]) => void,
  clearVehicle: () => void
}

export const VehicleContext = createContext<IVehicleContext | null>(null);

export const VehicleProvider = (props: any) => {
  const [vehicle, setVehicle] = useState<Vehicle | undefined>();
  const [capacityFull, setCapacityFull] = useState<[number, number] | undefined>();
  const [powerMaxStandard, setPowerMaxStandard] = useState<number | undefined>();
  const [powerMaxFast, setPowerMaxFast] = useState<number | undefined>();
  const [basicConnectors, setBasicConnectors] = useState<BasicConnectors>();
  const [optionalConnectors, setOptionalConnectors] = useState<string[]>([]);

  const clearOptionalConnectors = () => {
    setOptionalConnectors([]);
  }

  const clearVehicle = () => {
    setVehicle(undefined)
    setPowerMaxFast(undefined)
    setPowerMaxStandard(undefined)
    setBasicConnectors(undefined);
    setOptionalConnectors([]);
  }

  const values = useMemo(
    () => ({
      basicConnectors, optionalConnectors, powerMaxStandard, vehicle, powerMaxFast, capacityFull,
      setCapacityFull, setPowerMaxFast, setVehicle, setPowerMaxStandard, clearOptionalConnectors, setBasicConnectors, setOptionalConnectors, clearVehicle
    }),
    [vehicle, powerMaxStandard, basicConnectors, optionalConnectors]
  );

  return (
    <VehicleContext.Provider value={values}>
      {props.children}
    </VehicleContext.Provider>
  );
};